import { Tabs } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { theme } from "../constants/theme";

export const CustomTabs = (props: any) => {
  return (
    <AntTabs
      style={{ display: "flex", flexDirection: "column" }}
      value={props.value}
      onChange={props.onChange}
    >
      {props.children}
    </AntTabs>
  );
};
const AntTabs = withStyles({
  root: {},
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
})(Tabs);
